import React from 'react';
import { Route } from 'react-router-dom';
import PropTypes from 'prop-types';
import { Logger } from 'services';

class LazyRoute extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      Component: undefined,
    };
  }

  componentDidMount() {
    const { module } = this.props;
    module()
      .then(obj => {
        this.setState({ Component: obj });
      })
      .catch(Logger.error);
  }

  render() {
    const { Component } = this.state;
    const { path, ...routerProps } = this.props;

    if (Component?.default?.init) {
      return (
        <Route
          path={path}
          {...routerProps}
          component={Component.default.init}
        />
      );
    }

    return null;
  }
}

LazyRoute.displayName = 'LazyRoute';

LazyRoute.propTypes = {
  path: PropTypes.string,
  module: PropTypes.func.isRequired,
};

LazyRoute.defaultProps = {
  path: null,
};

export default LazyRoute;
